export const APPLICATION_PURPOSE_OTHER = "Other";

const OTHER_PURPOSE_VARIANTS = new Set([
	"other-purpose",
	"cash-loan-other-purpose",
]);

export const isOtherPurposeVariant = (variantType?: string): boolean =>
	variantType ? OTHER_PURPOSE_VARIANTS.has(variantType) : false;

export const isCashLoanCustomerVariant = (variantType?: string): boolean =>
	variantType === "cash-loan" || variantType === "cash-loan-other-purpose";

type PurposeContext = {
	purpose?: string;
	isCoapplicant?: boolean;
};

export const resolveApplicationPurpose = (
	context: PurposeContext
): string | undefined => context.purpose;

export const shouldShowLoanPurposeSelect = (
	applicationPurpose?: string
): boolean => applicationPurpose === APPLICATION_PURPOSE_OTHER;

export const shouldShowLoanPurposeSelectFromContext = (
	context: PurposeContext
): boolean => {
	const applicationPurpose = resolveApplicationPurpose(context);

	if (shouldShowLoanPurposeSelect(applicationPurpose)) {
		return true;
	}

	// FLOW requires `purpose` on submit, so when the application carried none the
	// main applicant has to supply it. Co-applicants are never asked.
	return !applicationPurpose && !context.isCoapplicant;
};

/**
 * The purpose to submit: the customer's pick when they were asked, otherwise the
 * purpose the application already decided. Undefined only when the context
 * carries none and the customer was not asked, which FLOW rejects.
 */
export const resolveSubmitPurpose = (
	context: PurposeContext,
	selectedLoanPurpose: string
): string | undefined =>
	shouldShowLoanPurposeSelectFromContext(context)
		? selectedLoanPurpose || undefined
		: resolveApplicationPurpose(context);
